<template>
  <v-card data-automationId="post" color="indigo" variant="outlined" class="postDetail">
    <p class="author"><v-icon icon="mdi-account" color="primary"></v-icon> <span data-automationId="postAutor" >{{ post.author }}</span></p>
    <h2 data-automationId="postTitle">{{ post.title }}</h2>
    <p data-automationId="postBody">{{ post.body }}</p>
    <div class="newComment">
      <v-text-field data-automationId="newComment" class="input" type="text" placeholder="Write a comment..." v-model="newComment" />
      <v-btn data-automationId="newCommentPostButton" class="button" color="primary" @click="submitComment">Post</v-btn>
    </div>

    <div class="comments">
      <div data-automationId="comment" class="comment" v-for="comment in comments" :key="comment.id">
        <div class="avatar">
          <v-icon class="icon" icon="mdi-account" color="primary" size="30"></v-icon>
        </div>
        <div class="detail">
          <div class="author" data-automationId="commentAuthor">{{ comment.author }}</div>
          <div class="text" data-automationId="commentText">{{ comment.text}}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getDatabase, ref, push, child } from 'firebase/database';

export default {
  props: ['post', 'comments', 'postId'],
  data() {
    return {
      newComment: ''
    };
  },
  methods: {
    submitComment() {
      const currentUser = this.$store.getters.currentUser;
      if (!currentUser) {
        alert('Bitte loggen Sie sich ein, um einen Kommentar zu posten.');
        return;
      }

      const db = getDatabase();
      console.log("post", {
        text: this.newComment,
        author: currentUser.displayName || currentUser.email,
        uid: currentUser.uid
      });
      push(child(ref(db), `post-comments/${this.postId}`), {
        text: this.newComment,
        author: currentUser.displayName || currentUser.email,
        uid: currentUser.uid
      });
      this.newComment = '';
    }
  }
}
</script>

<style scoped>

.postDetail {
  width: 500px;
  margin: 20px auto;
  padding: 20px;
}
.comments{
  margin-top: 10px;
}
.comment {
  margin: 10px 0;
}
.comment .avatar{
  display: inline-block;
  width: 30px;
  margin-right: 15px;
}
.comment .avatar .icon{
  top: -15px;
}
.comment .detail{
  display: inline-block;
}
.comment .detail .text{
  color: grey;
}
.newComment {
  margin-top: 20px;
}
.newComment .input {
  display: inline-block;
  width: calc(80% - 10px);
}
.newComment .button {
  display: inline-block;
  width: 20%;
  top: -45px;
  margin-left: 5px;
}
/* Your CSS here */
</style>
